module.exports = __webpack_public_path__ + "static/img/title-button-selected2.98dddd3d.png";